import { app } from '../../../../app';

app.component('userPasswordManagerConfirmRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-remove.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/confirm-remove/confirm-remove.component.js